import { Stack, StackProps, Typography, TypographyProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CardResourceStack = styled(Stack)<StackProps & {
  $disabled: boolean
}>(({ theme, $disabled }) => ({
  "&:hover": {
    borderColor: theme.customColors.borderAccent
  },
  alignItems: "center",
  background: theme?.customColors?.backgroundCard,
  border: `0.06rem solid ${theme.customColors.border}`,
  borderRadius: "0.5rem",
  cursor:"pointer",
  flexDirection: "row",
  gap: "0.5rem",
  maxWidth: "100%",
  padding: "0.5rem",
  width: "19rem",
  height: "2rem",
  ...$disabled && {
    cursor: "not-allowed"
  }
}));
export const TypographyResourceLabel = styled(Typography)<TypographyProps>(({ theme  }) => ({
  color: theme.customColors.exploreCardText,
  fontWeight: "400",
  fontSize: "0.75rem",
  fontStyle: "regular",
  maxWidth: "15rem",
  lineHeight: "1rem"
}));
